// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2jxsY","content":"ManualTimeModal_content__1Hl2S"};